import React from 'react';

type Props = {
  className?: string;
};

const PPMBackground: React.FC<Props> = ({ className = '' }) => (
  <span aria-hidden="true" className={`block ${className}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 80"
      fill="none"
      preserveAspectRatio="none"
      className="block h-full w-full"
    >
      <path d="M10 -20C30 5 -10 25 10 50C30 75 -10 95 10 120" stroke="#D9D9D9" strokeOpacity="0.6" strokeWidth="2" />
      <path d="M25 -20C45 5 5 25 25 50C45 75 5 95 25 120" stroke="#D9D9D9" strokeOpacity="0.6" strokeWidth="2" />
      <path d="M40 -20C60 5 20 25 40 50C60 75 20 95 40 120" stroke="#D9D9D9" strokeOpacity="0.6" strokeWidth="2" />
      <path d="M55 -20C75 5 35 25 55 50C75 75 35 95 55 120" stroke="#D9D9D9" strokeOpacity="0.6" strokeWidth="2" />
    </svg>
  </span>
);

export default PPMBackground;
